import { getQueryParam } from './query/getQueryParam.ts';
import { getQueryParams } from './query/getQueryParams.ts';
import { toQueryString } from './query/toQueryString.ts';

export interface LocationObject {
  hash: string;
  search: string;
  pathname: string;
  href: string;
  reload: () => void;
}

export class LocationProvider {
  locationObject: LocationObject;

  constructor(locationObject: LocationObject = location) {
    this.locationObject = locationObject;
  }

  get hash() {
    return this.locationObject.hash;
  }

  set hash(value: string) {
    if (value && !value.startsWith('#')) {
      value = `#${value}`;
    }

    this.locationObject.hash = value;
  }

  get search() {
    return this.locationObject.search;
  }

  set search(value: string) {
    if (value && !value.startsWith('?')) {
      value = `?${value}`;
    }

    this.locationObject.search = value;
  }

  get pathname() {
    return this.locationObject.pathname;
  }

  set pathname(value: string) {
    this.locationObject.pathname = value;
  }

  get href() {
    return this.locationObject.href;
  }

  set href(value) {
    this.locationObject.href = value;
  }

  get queryParams() {
    return getQueryParams(this.search);
  }

  getQueryParam(queryParam: string) {
    return getQueryParam(queryParam, this.search);
  }

  setQueryParam(queryParam: string, value: string) {
    const { queryParams } = this;
    queryParams[queryParam] = value;

    this.search = toQueryString(queryParams);
  }

  reload() {
    this.locationObject.reload();
  }
}
  
export const locationProvider = new LocationProvider();